import { t } from "@lingui/macro";
import { Loader2 } from "lucide-react";
import { SettingsGroup } from "./SettingsGroup";

export function ToolLoadingCard({ title }: { title: string }) {
	return (
		<SettingsGroup
			header={<h3>{title}</h3>}
			description={t({
				id: "settings.toolLoadingDescription",
				message: "Checking tool availability and configuration.",
			})}
		>
			<div
				role="status"
				aria-busy="true"
				className="flex items-center gap-2 text-sm text-muted-foreground"
			>
				<Loader2 aria-hidden="true" className="h-4 w-4 animate-spin" />
				{t({ id: "loading", message: "Loading..." })}
			</div>
		</SettingsGroup>
	);
}
